import React, { useContext } from 'react'
import PropTypes from 'prop-types'

import {
  StyledDrawerSubList,
  StyledDrawerMainList,
  StyledDrawerNavbar,
} from './Drawer.styled'
import LayoutContext from '../../contexts/LayoutContext'
import Collapse, { CollapseEnumType } from '../Collapse/Collapse'
import { handleOverflow } from '../../utils/HandleOverflow'

const Drawer = ({ links }) => {
  const navItemsGenerator = (links, level, parentSlug, isChild = false) => {
    return links.map((link) => {
      if (link.pageReference === null && link.slug === null) return
      const currentSlug = `/${link.pageReference?.slug ?? link.slug}`
      const sublinks =
        link.subNavigationItems &&
        navItemsGenerator(link.subNavigationItems, level + 1, currentSlug, true)
      return (
        <Collapse
          collapseType={CollapseEnumType.Navbar}
          isChild={isChild}
          key={link.id}
          name={link.name}
          to={currentSlug}
          level={level}
        >
          {sublinks && <StyledDrawerSubList>{sublinks}</StyledDrawerSubList>}
        </Collapse>
      )
    })
  }

  const navItems = navItemsGenerator(links, 0)
  const layoutState = useContext(LayoutContext)

  handleOverflow(layoutState.menuIsOpen)

  return (
    <StyledDrawerNavbar
      $isOpen={layoutState.menuIsOpen}
      aria-label="navigation"
    >
      <StyledDrawerMainList>{navItems}</StyledDrawerMainList>
    </StyledDrawerNavbar>
  )
}

Drawer.propTypes = {
  links: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Drawer
